import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { Icon } from '@magalu/stereo-ui-icons';
import { string } from 'prop-types';
import Image from '../../atoms/ResponsiveImage';
import { Container } from './avatar.styles';

const Avatar = _ref => {
  let {
    src,
    alt,
    fill,
    dataTesteIdImage,
    dataTesteIdIcon,
    iconName
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "alt", "fill", "dataTesteIdImage", "dataTesteIdIcon", "iconName"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "avatar"
  }, props), src ? /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt,
    "data-testid": dataTesteIdImage
  }) : /*#__PURE__*/React.createElement(Icon, {
    fill: fill,
    name: iconName,
    "data-testid": dataTesteIdIcon
  }));
};

process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  src: string,
  alt: string,
  dataTesteIdImage: string,
  dataTesteIdIcon: string,
  fill: string,
  iconName: string
} : void 0;
Avatar.defaultProps = {
  src: '',
  alt: '',
  fill: '#2FA0FD',
  iconName: 'UserReviewIcon'
};
export default Avatar;